'use strict';

angular.module('app').directive('descriptionCollapse', function($window, $timeout) {
    var link = function(scope, element) {
        $timeout(function() {
            var elem = $(element),
                showMoreBtn = elem.parent().children('.more');

            if (elem.innerHeight() <= 250 && !elem.hasClass('hidden-elem')) {
                scope.descriptionCollapse = false;
                showMoreBtn.hide();
            } else {
                scope.descriptionCollapse = true;
            }
        }, 350);
    };
    return {
        restrict: 'A',
        replace: false,
        scope: {
            descriptionCollapse: '='
        },
        link: link
    };
})